export const InfoTeaserGroupWidgetId = 'InfoTeaserGroupWidget';

export enum InfoTeaserGroupWidgetAttributes {
  HEADLINE_COMPONENT = 'infoTeaserGroupHeadlineComponent',
  ITEMS = 'infoTeaserGroupItems',
}
